<template>
    <v-layout
        wrap
        row
        align-start
    >
        <v-layout wrap>
            <v-flex xs12>
                <v-card class="card--flex-toolbar">
                    <v-toolbar flat>
                        <v-btn
                            icon
                            @click="$router.back()"
                        >
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                        <v-toolbar-title class="grey--text">detalles del monedero</v-toolbar-title>
                        <v-spacer/>
                    </v-toolbar>
                </v-card>
            </v-flex>
            <v-flex
                grow
                pa-1
                xs12
                md4
            >
                <v-card
                    color="primary"
                    dark
                >
                    <v-img
                        :src=" '/static/'+$root.app_meta.app_folder +  '/monedero-background.jpg'"
                        class="white--text"
                        height="200px"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title
                            class="fill-height align-end"
                        >
                            <v-overlay
                                :absolute="true"
                                :opacity="1"
                                :value="loading_monedero"
                            >
                                Cargando ...
                            </v-overlay>
                            <v-dialog
                                v-model="dialog_saldo"
                                width="500"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        dark
                                        text
                                        outlined
                                        v-on="on"
                                    >
                                        {{monedero ? $_currency(monedero.saldo_global) : ''}}
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-card-title
                                        class="headline grey lighten-2"
                                        primary-title
                                    >
                                        Detalles del saldo
                                    </v-card-title>

                                    <v-card-text>
                                        <v-list two-line>
                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{monedero ? $_currency(monedero.saldo_pagado) :
                                                        ''}}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>Saldo pagado</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content>
                                                    <v-list-item-title>{{monedero ?
                                                        $_currency(monedero.saldo_recompensa) : ''}}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>Saldo por recompensa</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="primary"
                                            text
                                            @click="dialog_saldo = false"
                                        >
                                            Entendido
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-title>
                    </v-img>
                    <v-card-actions>
                        {{cliente ? cliente.nombre_completo : ''}}
                        <v-spacer></v-spacer>
                        <v-btn text outlined @click="dialog_form_monedero = true;">Modificar saldo</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex
                grow
                pa-1
                xs12
                md8
            >
                <v-data-table
                    :headers="headers"
                    :items="historial"
                    :options.sync="options"
                    class="elevation-1"
                    :sort-by="'created_at'"
                    :sort-desc="true"
                    :footer-props="{itemsPerPageOptions : $root.OPTIONS_PER_PAGE_DATATABLE}"
                    :server-items-length="historialTotal"
                    :loading="loading_historial_monedero"
                    @update:options="listHistorial"
                >
                    <template v-slot:item.monto="{item}">
                        <span :class="formatMonto(item.tipo_registro)">{{$_currency(item.monto)}}</span>
                    </template>
                    <template v-slot:item.user_id="{item}">
                        {{ item.user_id ? item.user.nombre_completo : ''}}
                    </template>
                    <template v-slot:item.tipo_registro="{item}">
                        {{ getTipoRegistro(item.tipo_registro)}}
                    </template>
                </v-data-table>
            </v-flex>
            <v-dialog
                v-model="dialog_form_monedero"
                max-width="800px"
            >
                <FormSaldoMonedero
                    v-if="dialog_form_monedero"
                    :monedero-id="monedero.id"
                    :cliente-id="cliente.id"
                    :nombre-cliente="cliente.nombre_completo"
                    @form:close="dialog_form_monedero = false"
                    @form:save="loadMonedero"
                />
            </v-dialog>
        </v-layout>
    </v-layout>
</template>

<script>
    import axios from 'axios';
    import EventBus from "@/EventBus";
    import {TIPO_REGISTRO_MONEDERO} from '@/constants';

    import FormSaldoMonedero from "@components/FormSaldoMonedero";


    export default {
        name: "ClientesMonedero",
        components: {
            FormSaldoMonedero,
        },
        props: {
            clienteId: {
                type: [Number, String],
                default: 0,
                required: true
            }
        },
        data() {
            return {
                dialog_saldo: false,
                monedero: null,
                cliente: null,
                headers: [
                    {
                        text: 'Usuario',
                        align: 'left',
                        sortable: false,
                        value: 'user_id',
                        width: '150px'
                    },
                    {
                        text: 'Monto',
                        align: 'right',
                        sortable: false,
                        value: 'monto'
                    },
                    {
                        text: 'Tipo registro',
                        align: 'left',
                        sortable: false,
                        value: 'tipo_registro'
                    },
                    {
                        text: 'Comentarios',
                        align: 'left',
                        sortable: false,
                        value: 'comentarios'
                    },
                    {
                        text: 'Fecha',
                        align: 'left',
                        sortable: false,
                        value: 'created_at'
                    }
                ],
                options: {
                    descending: true,
                    page: 1,
                    itemsPerPage: this.$root.OPTIONS_PER_PAGE_DATATABLE[0],
                    totalItems: 0
                },
                historial: [],
                historialTotal: 0,
                /**/
                loading: false,
                loading_monedero: false,
                loading_cliente: false,
                loading_historial_monedero: false,
                estatus_list: [],
                dialog_form_monedero: false,
                TIPO_REGISTRO_MONEDERO
            }
        },
        computed: {},
        mounted() {
            this.loadCliente();
        },
        methods: {
            getTipoRegistro(tipo) {
                let tipo_find = this.TIPO_REGISTRO_MONEDERO.find((item) => item.id === tipo);

                return tipo_find ? tipo_find.text : '';
            },
            formatMonto(tipo) {
                switch (tipo) {
                    case 'add' :
                    case 'buy' :
                    case 'refund' :
                        return 'green--text';
                    case 'gif_order' :
                    case 'gif_buy_balance' :
                        return 'light-blue--text darken-4';
                    case 'remove':
                    case 'pay':
                        return 'red--text';
                    case 'donate':
                        return 'deep-purple--text accent-4';
                    default:
                        return 'grey--text text-lighten-4';
                }
            },
            loadCliente() {
                this.loading_cliente = true;
                axios.get('/api/clientes/ver/' + this.clienteId)
                .then((resultOk) => {
                    this.cliente = resultOk.data.data;
                    this.loadMonedero()
                })
                .catch(() => {
                    EventBus.$emit('tugarrafon:show-snackbar', {
                        color: 'error',
                        text_content: 'No pudimos obtener la información del cliente'
                    });
                    this.$router.back();
                }).finally(() => {
                    this.loading_cliente = false;
                });
            },
            loadMonedero() {
                this.loading_monedero = true;
                axios.get('/api/clientes/monedero/ver/' + parseInt(this.cliente.id)).then((responseOk) => {
                    //let {data} = responseOk;

                    let {data: {data: monedero}} = responseOk;
                    /*window.console.log('all response ', data_response);*/

                    this.monedero = monedero;
                    this.listHistorial();
                }).catch(() => {

                }).finally(() => {
                    this.loading_monedero = false;
                });
            },
            listHistorial() {
                if (this.monedero) {
                    this.loading_historial_monedero = true;
                    this.dialog_form_monedero = false;
                    const {sortBy, descending, page, itemsPerPage} = this.options;
                    axios.get('/api/clientes/monedero/historial/' + this.monedero.id, {
                        params: {
                            sortBy: sortBy, descending: descending, page: page, rowsPerPage: itemsPerPage,
                            search: this.search
                        }
                    }).then((success) => {
                        this.loading = false;
                        let {data} = success;
                        this.historial = data.data;
                        this.options.page = data.current_page;
                        this.historialTotal = data.total;
                    }).finally(() => {
                        this.loading_historial_monedero = false;
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
